import { Facebook, MessageSquareText, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

const btn = "flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold transition-colors";

export function ShareButtons({ url, text }) {
  const enc = encodeURIComponent;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); } catch { toast.error("Couldn't copy — long-press the link instead"); }
  };
  const native = () => navigator.share({ title: "ISoldIt", text, url }).catch(() => {});

  return (
    <div data-testid="share-buttons" className="flex flex-wrap gap-2">
      <a data-testid="share-facebook-btn" href={`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`} target="_blank" rel="noopener noreferrer" className={`${btn} bg-[#1877F2] text-white hover:bg-[#166fe0]`}>
        <Facebook className="h-4 w-4" /> Facebook
      </a>
      <a data-testid="share-sms-btn" href={`sms:?&body=${enc(`${text} ${url}`)}`} className={`${btn} bg-white/10 hover:bg-white/15`}>
        <MessageSquareText className="h-4 w-4" /> Text
      </a>
      <a data-testid="share-whatsapp-btn" href={`https://wa.me/?text=${enc(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" className={`${btn} bg-white/10 hover:bg-white/15`}>
        <MessageSquareText className="h-4 w-4" /> WhatsApp
      </a>
      <button data-testid="share-copy-btn" onClick={copy} className={`${btn} bg-white/10 hover:bg-white/15`}>
        <Link2 className="h-4 w-4" /> Copy link
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button data-testid="share-native-btn" onClick={native} className={`${btn} bg-[#d4f253] text-[#0f2a33] hover:bg-[#c2e23d]`}>
          <Share2 className="h-4 w-4" /> More
        </button>
      )}
    </div>
  );
}
